// src/containers/Receptions/ReceptionList/types/index.ts
import { Reception, Company } from "$types";
import ReceptionStatus from "$types/ReceptionStatus";

export enum RECEPTION_SYNCHRONIZED_STATUS {
  NOT_CONFIGURED = "",
  NOT_PUSHED = "Envoyer la réception",
  PUSHED = "Synchroniser la réception",
}

export enum RECEPTION_SYNCHRONIZED_STATUS_FILTER {
  NOT_CONFIGURED = "Non configuré",
  NOT_PUSHED = "À envoyer",
  PUSHED = "Envoyé",
}

export interface IReceptionsProps {
  className?: string;
}

export interface IReceptionFormPopinProps {
  reception: Reception | null;
  isSaving: boolean;
  onSubmit: (data: any) => Promise<void>;
  onReset: () => void;
  isReadOnly: boolean;
  open: boolean;
  togglePopin: (open: boolean) => void;
  onDelete?: () => void;
  canDelete?: boolean;
}

export interface IOrderFormPopinProps {
  order: any;
  orderNewValue: string | undefined;
  onSubmit: (data: any) => Promise<void>;
  onReset: () => void;
  onCancelOrder: () => void;
  defaultCompanyFilter?: any;
  showOrderModal: boolean;
  setShowOrderModal: (open: boolean) => void;
  setOrderNewValue: (value: string | undefined) => void;
}

export interface IReceptionFiltersProps {
  filters: any;
  setFilter: (key: string, value: any) => void;
  onAddReception?: () => void;
  dateStart_tfilter: Date | null;
  dateEnd_tfilter: Date | null;
  setDateStart_tfilter: (date: Date | null) => void;
  setDateEnd_tfilter: (date: Date | null) => void;
  onDateChange: (dates: any) => void;
  synchronization_tfilter: RECEPTION_SYNCHRONIZED_STATUS_FILTER | null;
  setSynchronization_tfilter: (
    status: RECEPTION_SYNCHRONIZED_STATUS_FILTER | null
  ) => void;
  exportReceptions: () => Promise<void>;
  isExporting: boolean;
  selectedRowsReception: Reception[];
}

export interface IReceptionListTableProps {
  columns: any[];
  receptions: Reception[];
  isFetching: boolean;
  pageCount: number;
  filters: any;
  setFilter: (key: string, value: any) => void;
  setPageIndex: (index: number) => void;
  pageIndex: number;
  renderRowSubComponent: (props: { row: any }) => JSX.Element | null;
  setSelectedRowsReception: (rows: Reception[]) => void;
  selectedRowsReception: Reception[];
}

export interface IOrderSelectWrapperProps {
  currentReception: Reception;
  companiesOptions: Company[];
  isAdmin: boolean;
  currentTab: number;
  onOrderSelectValueChanged: (
    reception: Reception
  ) => (newValues: any, newOrders: any) => Promise<void>;
}

export const newEmptyReception = {
  company: "",
  files: [],
  orders: [],
  provider: "",
  receptionDate: undefined,
  reference: "",
  warehouse: "",
  warehouseReference: "",
  status: ReceptionStatus.TODO,
  isTransfer: false,
};
